module.exports = __webpack_public_path__ + "img/left-div.4c4d7c5a.jpg";